import React, {useRef} from "react";
import html2pdf from "html2pdf.js";
import img from "../plateform/assets/logo/Fichier 1@2x.png"
import { BsDownload } from 'react-icons/bs'

// import { useRef } from "react";
// import html2pdf from "html2pdf.js";

const Invoice = ({ planSelected }) => {
  const invoiceRef = useRef();

  // Fonction pour générer le PDF
  const generatePDF = () => {
    const element = invoiceRef.current;
    const options = {
      margin: [0.5, 0.5, 0.5, 0.5], // Marges uniformes
      filename: `invoice_${planSelected?.plan || "default"}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 3 }, // Améliore la qualité du rendu
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    html2pdf().set(options).from(element).save();
  };

  return (
    <>
      <button
        onClick={generatePDF}
        className="px-4 py-2.5 bg-primary-green text-emerald-700 rounded hover:bg-primary-green/80"
      >
        <BsDownload className="stroke-1 text-base"></BsDownload>
      </button>
<div className="hidden">
      <div ref={invoiceRef} className="max-w-3xl mx-auto p-6 bg-white rounded shadow-sm my-6 text">
        <div className="grid grid-cols-2 items-center">
          <div>
          <img src={img} alt="company-logo" height="100" width="100"/>
          </div>
          <div className="text-right">
            <p>Tailwind Inc.</p>
            <p className="text-gray-500 text-sm">haisoa.conctact@gmail.com</p>
            <p className="text-gray-500 text-sm mt-1">+41-442341232</p>
            <p className="text-gray-500 text-sm mt-1">VAT: 8657671212</p>
          </div>
        </div>

        <div className="grid grid-cols-2 items-center mt-8 text-sm">
          <div>
            <p className="font-bold text-gray-800 text-sm">Facturé à :</p>
            <p className="text-gray-500 text-sm">
              {planSelected?.clientName || "Client inconnu"}
              <br />
              {planSelected?.clientAddress || "Adresse inconnue"}
            </p>
            <p className="text-gray-500 text-sm">{planSelected?.clientEmail || "Email inconnu"}</p>
          </div>
          <div className="text-right">
            <p>Numéro de facture: <span className="text-gray-500 text-sm">INV-{Date.now()}</span></p>
            <p>
              Date de facture: <span className="text-gray-500 text-sm">{new Date().toLocaleDateString()}</span>
              <br />
              Date d'échéance: <span className="text-gray-500 text-sm" >{planSelected?.dueDate || "31/07/2023"}</span>
            </p>
          </div>
        </div>

        <div className="-mx-4 mt-8 flow-root sm:mx-0">
        <table className="min-w-full">
          <thead className="border-b border-gray-300 text-gray-900">
             <tr className= "px-4">
               <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 ">Abonnement</th>
               <th scope="col" className=" px-3 py-3.5 text-right text-sm font-semibold text-gray-900 ">Quantity</th>
               <th scope="col" className=" px-3 py-3.5 text-right text-sm font-semibold text-gray-900 ">Prix</th>
               <th scope="col" className="py-3.5 pl-3 pr-4 text-right text-sm font-semibold text-gray-900 ">Total</th>
             </tr>
           </thead>
            <tbody>
              <tr className="border-b border-gray-200">
                <td className="py-4 px-4 text-sm">{planSelected?.plan || "Abonnement"}</td>
                <td className="py-4 px-4 text-right text-sm">1</td>
                <td className="py-4 px-4 text-right text-sm">${planSelected?.price || "0.00"}</td>
                <td className="py-4 px-4 text-right text-sm">${planSelected?.price || "0.00"}</td>
              </tr>
            </tbody>
            <tfoot>
            <tr>
                <th colSpan="3" className="py-3 px-4 text-right text-sm">Sous-total</th>
                <td className="py-3 px-4 text-right text-sm font-semibold">${planSelected?.price || "0.00"}</td>
              </tr>
              <tr>
                <th scope="row" colSpan="3" className="hidden pl-4 pr-3 pt-4 text-right text-sm font-normal text-gray-500 sm:table-cell sm:pl-0">Réduction</th>
                <th scope="row" className="pl-6 pr-3 pt-4 text-left text-sm font-normal text-gray-500 sm:hidden">Réduction</th>
                <td className="pl-3 pr-4 pt-4 text-right text-sm text-gray-500 sm:pr-0">0%</td>
              </tr>
              <tr>
                <th colSpan="3" className="py-3 px-4 text-right text-sm">Total</th>
                <td className="py-3 px-4 text-right text-sm font-semibold">${planSelected?.price || "0.00"}</td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div className="border-t-2 pt-4 text-xs text-gray-500 text-center mt-16">
          Merci pour votre souscription.
        </div>
      </div>  
</div>

    </>
  );
};

export default Invoice;


// const Invoice = () => {
//   // Fonction pour générer le PDF
//   const generatePDF = () => {
//     const element = document.getElementById("invoice"); // Cible la section HTML
//     const options = {
//       margin: 1,
//       filename: "invoice.pdf",
//       html2canvas: { scale: 2 }, // Meilleure qualité pour le rendu
//       jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
//     };

//     // Convertit le HTML en PDF
//     html2pdf().set(options).from(element).save();
//   };

//   return (
//     <>
//       <button
//           onClick={generatePDF}
//           className="px-6 py-3 bg-blue-500 text-white rounded hover:bg-blue-600"
//         >
//           Download PDF
//         </button>

//       <div className="max-w-3xl mx-auto p-6 bg-white rounded shadow-sm my-6" id="invoice">

// <div className="grid grid-cols-2 items-center">
//   <div>

//     <img src={img} alt="company-logo" height="100" width="100"/>
//   </div>

//   <div className="text-right">
//     <p>
//       Tailwind Inc.
//     </p>
//     <p className="text-gray-500 text-sm">
//       sales@tailwindcss.com
//     </p>
//     <p className="text-gray-500 text-sm mt-1">
//       +41-442341232
//     </p>
//     <p className="text-gray-500 text-sm mt-1">
//       VAT: 8657671212
//     </p>
//   </div>
// </div>

// <div className="grid grid-cols-2 items-center mt-8">
//   <div>
//     <p className="font-bold text-gray-800">
//       Bill to :
//     </p>
//     <p className="text-gray-500">
//       Laravel LLC.
//       <br />
//       102, San-Fransico, CA, USA
//     </p>
//     <p className="text-gray-500">
//       info@laravel.com
//     </p>
//   </div>

//   <div className="text-right">
//     <p className="">
//       Invoice number:
//       <span className="text-gray-500">INV-2023786123</span>
//     </p>
//     <p>
//       Invoice date: <span className="text-gray-500">03/07/2023</span>
//       <br />
//       Due date:<span className="text-gray-500">31/07/2023</span>
//     </p>
//   </div>
// </div>


// <div className="-mx-4 mt-8 flow-root sm:mx-0">
//   <table className="min-w-full">
//     <colgroup>
//       <col className="w-full sm:w-1/2"/>
//       <col className="sm:w-1/6"/>
//       <col className="sm:w-1/6"/>
//       <col className="sm:w-1/6"/>
//     </colgroup>
//     <thead className="border-b border-gray-300 text-gray-900">
//       <tr>
//         <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">Items</th>
//         <th scope="col" className="hidden px-3 py-3.5 text-right text-sm font-semibold text-gray-900 sm:table-cell">Quantity</th>
//         <th scope="col" className="hidden px-3 py-3.5 text-right text-sm font-semibold text-gray-900 sm:table-cell">Price</th>
//         <th scope="col" className="py-3.5 pl-3 pr-4 text-right text-sm font-semibold text-gray-900 sm:pr-0">Amount</th>
//       </tr>
//     </thead>
//     <tbody>
//       <tr className="border-b border-gray-200">
//         <td className="max-w-0 py-5 pl-4 pr-3 text-sm sm:pl-0">
//           <div className="font-medium text-gray-900">E-commerce Platform</div>
//           <div className="mt-1 truncate text-gray-500">Laravel based e-commerce platform.</div>
//         </td>
//         <td className="hidden px-3 py-5 text-right text-sm text-gray-500 sm:table-cell">500.0</td>
//         <td className="hidden px-3 py-5 text-right text-sm text-gray-500 sm:table-cell">$100.00</td>
//         <td className="py-5 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-0">$5,000.00</td>
//       </tr>
//     </tbody>
//     <tfoot>
//       <tr>
//         <th scope="row" colSpan="3" className="hidden pl-4 pr-3 pt-6 text-right text-sm font-normal text-gray-500 sm:table-cell sm:pl-0">Subtotal</th>
//         <th scope="row" className="pl-6 pr-3 pt-6 text-left text-sm font-normal text-gray-500 sm:hidden">Subtotal</th>
//         <td className="pl-3 pr-6 pt-6 text-right text-sm text-gray-500 sm:pr-0">$10,500.00</td>
//       </tr>
//       <tr>
//         <th scope="row" colSpan="3" className="hidden pl-4 pr-3 pt-4 text-right text-sm font-normal text-gray-500 sm:table-cell sm:pl-0">Tax</th>
//         <th scope="row" className="pl-6 pr-3 pt-4 text-left text-sm font-normal text-gray-500 sm:hidden">Tax</th>
//         <td className="pl-3 pr-6 pt-4 text-right text-sm text-gray-500 sm:pr-0">$1,050.00</td>
//       </tr>
//       <tr>
//         <th scope="row" colSpan="3" className="hidden pl-4 pr-3 pt-4 text-right text-sm font-normal text-gray-500 sm:table-cell sm:pl-0">Discount</th>
//         <th scope="row" className="pl-6 pr-3 pt-4 text-left text-sm font-normal text-gray-500 sm:hidden">Discount</th>
//         <td className="pl-3 pr-6 pt-4 text-right text-sm text-gray-500 sm:pr-0">- 10%</td>
//       </tr>
//       <tr>
//         <th scope="row" colSpan="3" className="hidden pl-4 pr-3 pt-4 text-right text-sm font-semibold text-gray-900 sm:table-cell sm:pl-0">Total</th>
//         <th scope="row" className="pl-6 pr-3 pt-4 text-left text-sm font-semibold text-gray-900 sm:hidden">Total</th>
//         <td className="pl-3 pr-4 pt-4 text-right text-sm font-semibold text-gray-900 sm:pr-0">$11,550.00</td>
//       </tr>
//     </tfoot>
//   </table>
// </div>

// <div className="border-t-2 pt-4 text-xs text-gray-500 text-center mt-16">
//   Please pay the invoice before the due date. You can pay the invoice by logging in to your account from our client portal.
// </div>

// </div>
//    </>
//    )
// }

// export default Invoice